export default __webpack_public_path__ + "static/media/orihiro.cc10b241.jpg";